var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery, useQueryClient, } from "@tanstack/react-query";
import { useAccountFeaturesQuery, } from "@syf-api-library/account-features";
import { useAccountSummaryV2Query as useAccountSummaryQuery, } from "@syf-api-library/account-summary";
import { useCreditAccountsQuery, } from "@syf-api-library/credit-accounts";
import { useProfileQuery, } from "@syf-api-library/profile";
import { useStatementsEnrollmentMutation, useStatementsEnrollmentQuery, } from "@syf-api-library/statements-enrollment";
import { useStatementsQuery, } from "@syf-api-library/statements";
import queryKeys from "./queryKeys";
import getConfig from "../helpers/getApiConfig";
import { useConfig } from "../hooks/useConfig";
import getPrivatePolicies from "../services/getPrivacyPolicies";
var useCreditAccounts = function (queryOptions) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var enabled = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getConfig(queryClient, mfeConfig, enabled, queryOptions);
    return useCreditAccountsQuery(__assign({}, apiConfig));
};
var useAccountSummary = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useAccountFeatures = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getConfig(queryClient, mfeConfig, Boolean(accountId));
    return useAccountFeaturesQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useStatements = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getConfig(queryClient, __assign(__assign({}, mfeConfig), { includeChangeInTerms: true }), Boolean(accountId));
    return useStatementsQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useStatementsEnrollment = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getConfig(queryClient, mfeConfig, Boolean(accountId));
    return useStatementsEnrollmentQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useStatementsEnrollmentUpdate = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var enabled = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getConfig(queryClient, mfeConfig, enabled);
    return useStatementsEnrollmentMutation(__assign({ keyProps: {
            accountId: accountId,
            accountIdType: "guid",
        } }, apiConfig));
};
var usePrivacyPolicyQuery = function () {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var enabled = true;
    var apiConfig = getConfig(queryClient, mfeConfig, enabled);
    return useQuery(__assign({ queryKey: [queryKeys.privacyPolicy], queryFn: function () { return getPrivatePolicies(mfeConfig); } }, apiConfig));
};
var useProfile = function (accountId) {
    var queryClient = useQueryClient();
    var mfeConfig = useConfig();
    var apiConfig = getConfig(queryClient, mfeConfig, Boolean(accountId));
    return useProfileQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
export { useAccountFeatures, useAccountSummary, useCreditAccounts, usePrivacyPolicyQuery, useProfile, useStatements, useStatementsEnrollment, useStatementsEnrollmentUpdate, };
